module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "blog"
  }, [_c('div', {
    staticClass: "blog__category-filter-container"
  }, [_c('div', {
    staticClass: "blog__category-filter-inner"
  }, [_c('div', {
    staticClass: "blog__category-filter"
  }, [_c('button', {
    staticClass: "blog__category-text",
    domProps: {
      "innerHTML": _vm._s(_vm.currentCategoryName)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.categoryFilterOpen = !_vm.categoryFilterOpen
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "services__category-buttons"
    }
  }, [(_vm.categoryFilterOpen) ? _c('div', {
    staticClass: "blog__category-buttons"
  }, [_c('button', {
    staticClass: "blog__category-button",
    on: {
      "click": _vm.selectAllCategories
    }
  }, [_vm._v("All Posts")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('button', {
      key: category.ID,
      staticClass: "blog__category-button",
      domProps: {
        "textContent": _vm._s(_vm.decode(category.name))
      },
      on: {
        "click": function($event) {
          _vm.selectCategory(category)
        }
      }
    })
  })], 2) : _vm._e()])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "blog__posts-container blog__posts-container--primary"
  }, [_c('section', {
    staticClass: "blog__posts"
  }, _vm._l((_vm.posts.slice(0, 5)), function(post, index) {
    return (post.post_preview || post.guid) ? _c('article', {
      staticClass: "blog__post wow fadeInUp",
      style: (_vm.hasLoadedMore ? 'visibility: visible;' : null),
      attrs: {
        "data-wow-delay": index * 0.15 + 's'
      }
    }, [(post.post_date) ? _c('div', {
      staticClass: "blog__post-date",
      domProps: {
        "textContent": _vm._s(_vm.convertDate(post.post_date) + ' / ')
      }
    }) : _vm._e(), _vm._v(" "), (post.date) ? _c('div', {
      staticClass: "blog__post-date",
      domProps: {
        "textContent": _vm._s(_vm.convertDate(post.date) + ' / ')
      }
    }) : _vm._e(), _vm._v(" "), (post.category_list) ? _c('div', {
      staticClass: "blog__post-category",
      domProps: {
        "textContent": _vm._s(_vm.getCategoryNames(post.category_list))
      }
    }) : _vm._e(), _vm._v(" "), (post.categories) ? _c('div', {
      staticClass: "blog__post-category",
      domProps: {
        "textContent": _vm._s(_vm.getCategoryNames(post.categories))
      }
    }) : _vm._e(), _vm._v(" "), (post.post_title) ? _c('a', {
      staticClass: "blog__post-heading",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s(post.post_title)
      }
    }) : _vm._e(), _vm._v(" "), (post.title) ? _c('a', {
      staticClass: "blog__post-heading",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s(_vm.decode(post.title.rendered))
      }
    }) : _vm._e(), _vm._v(" "), (post.post_preview) ? _c('div', {
      staticClass: "blog__post-content",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(post.post_preview))
      }
    }) : _c('div', {
      staticClass: "blog__post-content",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(post.acf.post_preview))
      }
    }), _vm._v(" "), (post.slug) ? _c('a', {
      staticClass: "blog__post-link",
      attrs: {
        "href": post.slug
      }
    }, [_vm._v("\n                    Read More\n                ")]) : _vm._e(), _vm._v(" "), _c('hr', {
      staticClass: "blog__post-hr"
    })]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    ref: "featuredPost",
    staticClass: "blog__post blog__post--featured",
    attrs: {
      "data-wow-delay": "0.25s"
    }
  }, [_vm._t("featured-post--primary")], 2)]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('section', {
    staticClass: "blog__posts-container blog__posts-container--secondary"
  }, [_c('section', {
    staticClass: "blog__posts blog__posts--secondary"
  }, _vm._l((_vm.posts.slice(5)), function(post, index) {
    return (post.post_preview || post.guid) ? _c('article', {
      staticClass: "blog__post wow fadeInUp",
      style: (_vm.hasLoadedMore ? 'visibility: visible;' : null),
      attrs: {
        "data-wow-delay": index * 0.15 + 's'
      }
    }, [(post.post_date) ? _c('div', {
      staticClass: "blog__post-date",
      domProps: {
        "textContent": _vm._s(_vm.convertDate(post.post_date))
      }
    }) : _vm._e(), _vm._v(" "), (post.date) ? _c('div', {
      staticClass: "blog__post-date",
      domProps: {
        "textContent": _vm._s(_vm.convertDate(post.date))
      }
    }) : _vm._e(), _vm._v(" "), (post.category_list) ? _c('div', {
      staticClass: "blog__post-category",
      domProps: {
        "textContent": _vm._s(_vm.getCategoryNames(post.category_list))
      }
    }) : _vm._e(), _vm._v(" "), (post.categories) ? _c('div', {
      staticClass: "blog__post-category",
      domProps: {
        "textContent": _vm._s(_vm.getCategoryNames(post.categories))
      }
    }) : _vm._e(), _vm._v(" "), (post.post_title) ? _c('a', {
      staticClass: "blog__post-heading",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s(post.post_title)
      }
    }) : _vm._e(), _vm._v(" "), (post.title) ? _c('a', {
      staticClass: "blog__post-heading",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s(_vm.decode(post.title.rendered))
      }
    }) : _vm._e(), _vm._v(" "), (post.post_preview) ? _c('div', {
      staticClass: "blog__post-content",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(post.post_preview))
      }
    }) : _c('div', {
      staticClass: "blog__post-content",
      domProps: {
        "textContent": _vm._s(_vm.spliceContent(post.acf.post_preview))
      }
    }), _vm._v(" "), (post.slug) ? _c('a', {
      staticClass: "blog__post-link",
      attrs: {
        "href": post.slug
      },
      domProps: {
        "textContent": _vm._s('Read More')
      }
    }) : _vm._e(), _vm._v(" "), _c('hr', {
      staticClass: "blog__post-hr"
    })]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "blog__post blog__post-featured_secondary"
  }, [_vm._t("featured-post--secondary")], 2)]), _vm._v(" "), (_vm.showLoadMore) ? _c('div', {
    staticClass: "blog__load-more-container"
  }, [_c('button', {
    staticClass: "blog__load-more",
    domProps: {
      "textContent": _vm._s(_vm.buttonText)
    },
    on: {
      "click": function($event) {
        _vm.getPosts(false)
      }
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ad93ba5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandBlog.vue
// module id = 265
// module chunks = 1